import { PlanCardConfig } from '@aibees/shared/definition';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import { useCurrentSubscriptionApi } from '../price-and-plan/api/use-current-subscription-api';
import { CreditSelect } from './components/credit-select';
import { PlanBillingCycle } from './components/plan-billing-cycle';
import { PlanDescription } from './components/plan-description';
import { PlanDynamicAction } from './components/plan-dynamic-action';
import { PlanInclusion } from './components/plan-inclusion';
import { PlanPrice } from './components/plan-price';
import { PlanTags } from './components/plan-tags';
import { PlanTitle } from './components/plan-title';
import { UpcomingPlanBadge } from './components/upcoming-plan-badge';
import { PlanCardProvider } from './context/provider';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanCardProps as Props } from './types';

export const PlanCard = memo(
  ({ className, plans, yearly, isFree, config, isLoading }: Props) => {
    const isPaid = !isFree;

    const { data } = useCurrentSubscriptionApi();
    const nextPlanIsFree = Boolean(data?.next?.plan?.metadata.is_free);

    return (
      <PlanCardProvider
        isPaid={isPaid}
        plans={plans}
        yearly={yearly}
        config={config || ({} as PlanCardConfig)}
        isLoading={isLoading}
      >
        <Box>
          <UpcomingPlanBadge />
          <Styled.Wrapper
            className={classnames('PlanCard', className, {
              nextPlanIsFree: nextPlanIsFree && isFree,
            })}
            sx={SX.root(isPaid)}
          >
            <PlanTags />
            <PlanTitle />
            <PlanDescription />
            <PlanPrice />
            <PlanBillingCycle />
            <PlanInclusion />
            <CreditSelect />
            <PlanDynamicAction />
          </Styled.Wrapper>
        </Box>
      </PlanCardProvider>
    );
  }
);

PlanCard.displayName = 'PlanCard';
